import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLang } from "@/hooks/useLang";
import { buildLangPath } from "@/utils/routeBuilders";
import Seo from "@/components/Seo";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation("not-found");
  const { lang } = useLang();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <Seo page="not-found" />
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">{t("title")}</h1>
        <p className="text-xl text-gray-600 mb-4">{t("message")}</p>
        <a href={buildLangPath(lang, "/")} className="text-blue-500 hover:text-blue-700 underline">
          {t("backHome")}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
